$( document ).ready(function() {
  
    $('body').on('click', '.BundleID', function(){
      var get_bundle = $(this).attr('data-bundle');
      console.log('get_bundle', get_bundle);
      var arrayRemove = [];
      if(get_bundle.length > 0){
        $('.BundleID[data-bundle="'+ get_bundle +'"]').each(function( index ) {
             var getID = $(this).attr('data-key');
             arrayRemove.push( $(this).attr("data-key") );
            
        });
      }

      console.log('arrayRemove', arrayRemove);
      
      removeItems(arrayRemove);
      
      
    });

    function removeItems(items) {
      var itemsProcessed = items;
      
      var itemsArray = items;
      var qty = 0;
      var data = { updates: {} };
     
      for (i = 0; i < itemsArray.length; i++) {
         data.updates[itemsArray[i]] = qty;
      }
    
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() { 
          location.reload();
        }
      });
    
     }
  
});